<template>
  <Header v-if="site === 'km'" />
  <router-view />
  <Footer v-if="site === 'km' && !isIndexRoute" />
  <BackToTopBtn v-if="site === 'km'" />
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import useLocale from "@/composables/useLocale";
import "animate.css";
import Header from "@/components/km/layouts/Header.vue";
import Footer from "@/components/km/layouts/Footer.vue";
import BackToTopBtn from "@/components/km/BackToTopBtn.vue";

const { initLocale } = useLocale();
initLocale();
const site = process.env.VUE_APP_SITE;
const route = useRoute();
const isIndexRoute = computed(() => route.name === "index");
</script>
